import React, { useEffect, useState, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Form, Card, FloatingLabel } from 'react-bootstrap';
import { s3url,showToastMessage, executeLaravelAPI,userToken,uploadAssets,validateName,appAbsPath,validatePhone,formatDateForDatepicker } from '../../Utils';
// import SubmitButton from '../../shared/SubmitButton';


const DeveloperEdit = ({ onCreateFormSubmit }) => {
    const buttonClass=useRef('theme-btn btn btn-success');
    const pageDetails={'pagetitle':'Edit Developer','pageslug':'edit-developer'};
    // const [buttonClassLoader, setButtonClass] = useState(buttonClass.current);
    const [editDeveloper, setEditedItem] = useState({
        name: '',
        nickname: '',
        description: '',
        is_active: false,
        is_primary: false,
        rating: 0,
        total_completed_projects: 0,
        total_ongoing_projects: 0,
        logo: '',
        established_time_stamp: '',
        website: '',
        years_of_experience: 0,
        sq_ft_delivered: 0,
        no_of_customers_served: 0,
        happy_customers: 0
        //location: ''
    });
    const { id } = useParams();
    const [developerLogo, setSelectedFile] = useState(null); 
    const [validationErrors, setValidationErrors] = useState({});
    //const [selectedLocation, setSelectedLocation] = useState(null);
    const [locationsData, setSelectedLocations] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);

    useEffect(() => {
        document.title = pageDetails.pagetitle;
        const getDeveloper = async () => {
            try {
                const result = await executeLaravelAPI(`developer/edit/${id}`, '', 'GET', userToken);
                const dataDeveloperDetails = result.data;
                //console.log(dataDeveloperDetails);
                setEditedItem({
                    name: dataDeveloperDetails.name,
                    nickname: dataDeveloperDetails.nickname,
                    description: dataDeveloperDetails.description,
                    is_active: dataDeveloperDetails.is_active,
                    is_primary: dataDeveloperDetails.is_primary,
                    rating: dataDeveloperDetails.rating,
                    total_completed_projects: dataDeveloperDetails.total_completed_projects,
                    total_ongoing_projects: dataDeveloperDetails.total_ongoing_projects,
                    logo: dataDeveloperDetails.logo,
                    established_time_stamp: formatDateForDatepicker(dataDeveloperDetails.established_time_stamp),
                    website: dataDeveloperDetails.website,
                    years_of_experience: dataDeveloperDetails.years_of_experience,
                    sq_ft_delivered: dataDeveloperDetails.sq_ft_delivered,
                    no_of_customers_served: dataDeveloperDetails.no_of_customers_served,
                    happy_customers: dataDeveloperDetails.happy_customers,
                    //location: dataDeveloperDetails.address?.location || ''
                });
                // setTimeout(() => {
                //     const citySelect = document.getElementById('sel1')?.value;
                //     if (citySelect) {
                //         getLocationsByCity(citySelect);
                //         setSelectedCity(citySelect);
                //     }
                // }, 5000);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        if (id) {
            getDeveloper();
        }
    }, [id]);

    const getLocationsByCity = async (city) => {
        try {
            const result=await executeLaravelAPI(`locations/city/${city}`, '', 'GET', userToken);
            const locationData=result.data;
            setSelectedLocations(locationData);            
        } catch (error) {
            console.error('Error fetching data:', error);
        } 
    };

    // const handleLocationChange = (event) => {
    //     const location = event.target.value;
    //     if (location === '') {
    //         return;
    //     }
    //     setEditedItem({
    //         ...editDeveloper,
    //         location: event.target.value
    //     });
    //     setSelectedLocation(location);
    // };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let slugValue;
        const updatedState = { [name]: value };
        if (name === 'name') {
            // slugValue = generateSlug(value);
            // updatedState.slug = slugValue;
            // updatedState.canonical_url = "/" + slugValue;
        }
        setEditedItem((prevState) => ({
            ...prevState,
            ...updatedState,
        }));
        
        // Validate the input
        let error = validateInput(name, value);
        setValidationErrors((prevErrors) => ({
            ...prevErrors,
            [name]: error,
        }));
    };
    
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setSelectedFile(file);
    };

    const validateInput = (name, value) => {
        let error = '';

        // Text fields (must be non-empty, same as Location form)
        if (['name', 'nickname'].includes(name)) {
            error = validateName(value);
        }

        // Required numeric fields – treat empty, non-numeric, or <= 0 as invalid
        if (
            [
                'rating',
                'total_completed_projects',
                'total_ongoing_projects',
                'no_of_customers_served',
                'sq_ft_delivered',
                'happy_customers',
            ].includes(name)
        ) {
            const numeric = Number(value);
            if (value === '' || value === null || isNaN(numeric) || numeric <= 0) {
                error = 'This field is required.';
            }
        }

        // Required date field – must be non-empty (same as Location form style)
        if (name === 'established_time_stamp') {
            if (!value || String(value).trim() === '') {
                error = 'Established timestamp is required.';
            }
        }

        return error;
    };
   
    const updateDeveloper = async (e) => {
        e.preventDefault();
        try {
            // Check for errors (same pattern as LocationAddNew)
            let hasErrors = false;
            const errors = {};

            // Only these fields are required in developer edit
            errors.total_completed_projects = validateInput('total_completed_projects', editDeveloper.total_completed_projects);
            errors.total_ongoing_projects = validateInput('total_ongoing_projects', editDeveloper.total_ongoing_projects);
            errors.established_time_stamp = validateInput('established_time_stamp', editDeveloper.established_time_stamp);
            

            for (const key in errors) {
                if (errors[key]) {
                    hasErrors = true;
                    break;
                }
            }

            // Set all validation errors at once so every field shows red text on save
            setValidationErrors(errors);
            if (hasErrors) return;

            const developerFormData = new FormData();
            if (developerLogo) {
                developerFormData.append(`logo`, developerLogo);
            }
            const response = await executeLaravelAPI(`developer/update/${id}`, editDeveloper,'PUT',userToken);
            if (developerLogo) {
                await uploadAssets(`developerassets/${response.data.id}`, developerFormData,userToken);
            }
            if (response.status === 200) {
                showToastMessage('Developer edited successfully', 'top-right', 'success');
            } else {
                showToastMessage('Developer edition failed', 'top-right', 'error');
            }
        } catch (error) {
            showToastMessage('Error updating developer', 'top-right', 'error');
        }
        if (onCreateFormSubmit) {
            onCreateFormSubmit(editDeveloper);
        }
    };

    return (
        <form onSubmit={updateDeveloper} className='developerForm' encType="multipart/form-data">
            <div className="row">
                <div className="col-md-12 mb-2">
                    <Card border="" style={{ width: '100%' }}>
                        <Card.Header>Edit "{editDeveloper.name}" Developer</Card.Header>
                        <Card.Body>
                                <div className="row">
                                    <div className="col-md-12 mb-2">
                                        <Form.Group className="row">
                                            <div className="col-sm-12">
                                                <FloatingLabel controlId="floatingInput" label="Developer Name">
                                                    <Form.Control
                                                        placeholder="Developer Name"
                                                        type="text"
                                                        name='name'
                                                        value={editDeveloper.name || ''}
                                                        onChange={handleInputChange}
                                                        disabled={false}
                                                        readOnly={false}
                                                        isInvalid={!!validationErrors.name}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {validationErrors.name}
                                                    </Form.Control.Feedback>
                                                </FloatingLabel>
                                            </div>
                                        </Form.Group>
                                    </div>
                                    {/* <hr/>
                                    <div className="col-md-12 mb-2">
                                        <Form.Group className="row">
                                            <div className="col-sm-12">
                                                <FloatingLabel controlId="floatingInput" label="Developer Name">
                                                    <Form.Control
                                                        placeholder="Developer Name"
                                                        type="text"
                                                        name='nickname'
                                                        value={editDeveloper.nickname || ''}
                                                        onChange={handleInputChange}
                                                        disabled={false}
                                                        readOnly={false}
                                                        isInvalid={!!validationErrors.nickname}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {validationErrors.nickname}
                                                    </Form.Control.Feedback>
                                                </FloatingLabel>
                                            </div>
                                        </Form.Group>
                                    </div> */}
                                   
                                    <hr/>
                                    
                                    <div className="col-md-6 mb-2">
                                        <Form.Group className="row">
                                            <div className="col-sm-12">
                                                <FloatingLabel controlId="floatingInput" label="Total Completed Projects">
                                                    <Form.Control
                                                        placeholder="Total Completed Projects"
                                                        type="number"
                                                        name='total_completed_projects'
                                                        value={editDeveloper.total_completed_projects || ''}
                                                        onChange={handleInputChange}
                                                        disabled={false}
                                                        readOnly={false}
                                                        isInvalid={!!validationErrors.total_completed_projects}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {validationErrors.total_completed_projects}
                                                    </Form.Control.Feedback>
                                                </FloatingLabel>
                                            </div>
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <Form.Group className="row">
                                            <div className="col-sm-12">
                                                <FloatingLabel controlId="floatingInput" label="Total Ongoing Projects">
                                                    <Form.Control
                                                        placeholder="Total Ongoing Projects"
                                                        type="number"
                                                        name='total_ongoing_projects'
                                                        value={editDeveloper.total_ongoing_projects || ''}
                                                        onChange={handleInputChange}
                                                        disabled={false}
                                                        readOnly={false}
                                                        isInvalid={!!validationErrors.total_ongoing_projects}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {validationErrors.total_ongoing_projects}
                                                    </Form.Control.Feedback>
                                                </FloatingLabel>
                                            </div>
                                        </Form.Group>
                                    </div>

                                    {/* <div className="col-md-6 mb-2">
                                        <Form.Group className="row">
                                            <div className="col-sm-12">
                                                <FloatingLabel controlId="floatingInput" label="Years Of Experience">
                                                    <Form.Control
                                                        placeholder="Years Of Experience"
                                                        type="number"
                                                        name='years_of_experience'
                                                        value={editDeveloper.years_of_experience || ''}
                                                        onChange={handleInputChange}
                                                        disabled={false}
                                                        readOnly={false}
                                                        isInvalid={!!validationErrors.years_of_experience}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {validationErrors.years_of_experience}
                                                    </Form.Control.Feedback>
                                                </FloatingLabel>
                                            </div>
                                        </Form.Group>
                                    </div> */}
                                    <div className="col-md-6 mb-2">
                                        <Form.Group className="row">
                                            <div className="col-sm-12">
                                                <FloatingLabel controlId="floatingInput" label="No of customers served">
                                                    <Form.Control
                                                        placeholder="No of customers served"
                                                        type="number"
                                                        name='no_of_customers_served'
                                                        value={editDeveloper.no_of_customers_served || ''}
                                                        onChange={handleInputChange}
                                                        disabled={false}
                                                        readOnly={false}
                                                        isInvalid={!!validationErrors.no_of_customers_served}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {validationErrors.no_of_customers_served}
                                                    </Form.Control.Feedback>
                                                </FloatingLabel>
                                            </div>
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <Form.Group className="row">
                                            <div className="col-sm-12">
                                                <FloatingLabel controlId="floatingInput" label="Happy customers">
                                                    <Form.Control 
                                                        placeholder="Happy customers" 
                                                        type="number" 
                                                        name='happy_customers' 
                                                        value={editDeveloper.happy_customers || ''} 
                                                        onChange={handleInputChange} 
                                                        disabled={false} 
                                                        readOnly={false}
                                                        isInvalid={!!validationErrors.happy_customers}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {validationErrors.happy_customers}
                                                    </Form.Control.Feedback>
                                                </FloatingLabel>
                                            </div>
                                        </Form.Group>
                                    </div>
                                    
                                    <div className="col-md-6 mb-2">
                                        <Form.Group className="row">
                                            <div className="col-sm-12">
                                                <FloatingLabel controlId="floatingInput" label="Sq.Ft. delivered">
                                                    <Form.Control 
                                                        placeholder="Sq.Ft. delivered" 
                                                        type="number" 
                                                        name='sq_ft_delivered' 
                                                        value={editDeveloper.sq_ft_delivered || ''} 
                                                        onChange={handleInputChange} 
                                                        disabled={false} 
                                                        readOnly={false}
                                                        isInvalid={!!validationErrors.sq_ft_delivered}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {validationErrors.sq_ft_delivered}
                                                    </Form.Control.Feedback>
                                                </FloatingLabel>
                                            </div>
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <Form.Group className="row">
                                            <div className="col-sm-12">
                                                <FloatingLabel controlId="floatingInput" label="Rating">
                                                    <Form.Control
                                                        placeholder="Rating"
                                                        type="number"
                                                        name='rating'
                                                        value={editDeveloper.rating || ''}
                                                        onChange={handleInputChange}
                                                        disabled={false}
                                                        readOnly={false}
                                                        isInvalid={!!validationErrors.rating}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {validationErrors.rating}
                                                    </Form.Control.Feedback>
                                                </FloatingLabel>
                                            </div>
                                        </Form.Group>
                                    </div>
                                    <hr/>
                                    {/* <div className="col-md-6 mb-2">
                                        <Form.Group className="row">
                                            <div className="col-sm-12">
                                                <FloatingLabel controlId="floatingInput" label="Location">
                                                    <select name="location" value={editDeveloper.location || ""} id="location" className={`form-control ${validationErrors.location ? 'is-invalid' : ''}`} onChange={handleLocationChange}>
                                                        <option value="">--Select Location--</option>
                                                        { 
                                                            locationsData &&
                                                                locationsData.map((locationObj, index) => (
                                                                    <option key={index} value={locationObj.location}>
                                                                        {locationObj.location}
                                                                    </option>
                                                                ))
                                                        }
                                                    </select>
                                                    {validationErrors.location && (
                                                        <Form.Control.Feedback type="invalid">
                                                            {validationErrors.location}
                                                        </Form.Control.Feedback>
                                                    )}
                                                </FloatingLabel>
                                            </div>
                                        </Form.Group>
                                    </div> */}
                                    <div className="col-md-6 mb-2">
                                        <Form.Group className="row">
                                            <div className="col-sm-12">
                                                <FloatingLabel controlId="floatingInput" label="Established Timestamp">
                                                    <Form.Control
                                                        placeholder="Established Timestamp"
                                                        type="date"
                                                        name='established_time_stamp'
                                                        value={editDeveloper.established_time_stamp || ''}
                                                        onChange={handleInputChange}
                                                        disabled={false}
                                                        readOnly={false}
                                                        isInvalid={!!validationErrors.established_time_stamp}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {validationErrors.established_time_stamp}
                                                    </Form.Control.Feedback>    
                                                </FloatingLabel>
                                            </div>
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <Form.Group className="row">
                                            <div className="col-sm-12">
                                                <FloatingLabel controlId="floatingInput" label="Logo">
                                                    <Form.Control type="file" className="form-control" accept="image/*" onChange={handleFileChange} />
                                                </FloatingLabel>
                                            </div>
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <Form.Group className="row">
                                            <div className="col-sm-12">
                                                <FloatingLabel controlId="floatingInput" label="Website">
                                                    <Form.Control placeholder="Website" type="text" name='website' value={editDeveloper.website || ''} onChange={handleInputChange} disabled={false} readOnly={false} />
                                                </FloatingLabel>
                                            </div>
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <Form.Group className="row">
                                            <div className="col-sm-12">
                                                { editDeveloper.logo?.url && editDeveloper.logo?.url !== '' ? (
                                                    <img src={`${s3url}${editDeveloper.logo?.url}`} width={100} alt={`${editDeveloper.name} Logo`} />
                                                    ) : 'No Logo'
                                                }
                                            </div>
                                        </Form.Group>
                                    </div>

                                    
                                    <hr/>
                                    <div className="col-md-12 mb-2">
                                        <Form.Group className="row">
                                            <div className="col-sm-12">
                                                <FloatingLabel controlId="floatingInput" label="Description">
                                                    <Form.Control placeholder="Description" type="text" name='description' value={editDeveloper.description || ''} onChange={handleInputChange} disabled={false} readOnly={false} />
                                                </FloatingLabel>
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>

                        </Card.Body>
                        <Card.Footer className="text-end text-muted">
                            <Link to={`${appAbsPath}/portaladmin/developers`} variant="secondary" className="theme-btn secondary me-2">Cancel</Link>
                            <Button variant="success" type="submit" className="theme-btn">Save</Button>
                        </Card.Footer>
                    </Card>
                </div>
            </div>
        </form>
    );
};

export default DeveloperEdit;
